// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    EORB1RecordCode,
    TORB1BackendRecord,
    TORB1HistoryFilters,
} from './@types';

enum EORB1Constants {
    FEATURE = '@orb-1',
    // API = '/marpol-oil-record-book1',
    API = '/api/marpol/all',
}
enum EORB1Actions {
    HISTORY_LOAD = '@orb-1/:history-load',

    HISTORY_SET = '@orb-1/${history}/set',

    SET_FILTER = '@orb1/:set-filter',
	
	GOTO_DASHBOARD = '@orb1/-->dashboard',
    GOTO_OPERATION_DASHBOARD = '@orb1/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@orb1/-->selected-operation',
    GOTO_HISTORY = '@orb1/-->history',
}

const orb1Actions = {
    commands: {
        historyLoad: createAction(
            EORB1Actions.HISTORY_LOAD,
            (providedFilters: TORB1HistoryFilters) => ({ providedFilters })
        )(),
    },
    document: {
        historySet: createAction(
            EORB1Actions.HISTORY_SET,
            (history: IListObjectStore<TORB1BackendRecord>) => ({ history })
        )(),
        setFilter: createAction(EORB1Actions.SET_FILTER, (filter: any) => ({
            filter,
        }))(),
    },
    routes: {
        gotoDashboard: createAction(EORB1Actions.GOTO_DASHBOARD)(),
        gotoOperationDashboard: createAction(
            EORB1Actions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            EORB1Actions.GOTO_SELECTED_OPERATION,
            (operationCode: EORB1RecordCode) => ({ operationCode })
        )(),
        gotoHistory: createAction(EORB1Actions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TORB1Actions = ActionType<typeof orb1Actions>;
export default orb1Actions;
export { EORB1Constants, EORB1Actions };
